import React from 'react'
import { AccordionItem, AccordionItemBody, AccordionItemTitle } from "react-accessible-accordion"

import TranslatedText from "../../TranslatedText"
import { __ } from "../../../services/i18n"

const AppearanceAndSensationAccordionItem = () => (
    <AccordionItem>
        <AccordionItemTitle>
            <h3>{ __('procedure_lumpectomy:accordion_2_heading') }</h3>
        </AccordionItemTitle>
        <AccordionItemBody>
            <p><TranslatedText translationKey="procedure_lumpectomy:accordion_2_paragraph_1" /></p>
            <p><TranslatedText translationKey="procedure_lumpectomy:accordion_2_paragraph_2" /></p>
            <p><TranslatedText translationKey="procedure_lumpectomy:accordion_2_paragraph_3" /></p>
            <p><TranslatedText translationKey="procedure_lumpectomy:accordion_2_paragraph_4" /></p>
            <p><TranslatedText translationKey="procedure_lumpectomy:accordion_2_paragraph_5" /></p>
        </AccordionItemBody>
    </AccordionItem>
)

export default AppearanceAndSensationAccordionItem
